// removed by extract-text-webpack-plugin
module.exports = {"save":"_2KAX","notification":"_2vZS","note-txt":"__kSr"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/themesection/style.css
// module id = qtbF
// module chunks = 4